import React from 'react';
import { progressBarContainer, progressBarWrapper } from './ProgressBar.styles';
import { Step } from './ProgressBarStep';

export interface IProgressBarStep {
  index: number;
  label: string;
}

export interface IProgressBarProps {
  steps: IProgressBarStep[];
  currentStep: number;
}

export const ProgressBar: React.FunctionComponent<IProgressBarProps> = ({ steps, currentStep }) => {
  const { classes: wrapperStyles } = progressBarWrapper({
    hideImage: steps.length - 1 === currentStep,
  })();
  const { classes: containerStyles } = progressBarContainer()();
  return (
    <div className={wrapperStyles.wrapper}>
      <div className={containerStyles.container}>
        {steps.map((step, index) => {
          const completed = index < currentStep;
          const active = index === currentStep;
          return (
            <Step
              active={active}
              completed={completed}
              index={index}
              key={`progressbar-step-${step.index}`}
              numberOfSteps={steps.length}
              step={step}
            />
          );
        })}
      </div>
    </div>
  );
};
